import { EntityId } from "@jackfruit/common"
import { nanoid } from "@reduxjs/toolkit"
import { SagaIterator } from "redux-saga"
import { call, delay, put, select } from "redux-saga/effects"
import { ImageEntity } from "~/interfaces/entities/Image"
import { ImageTransformationEntity } from "~/interfaces/entities/ImageTransformation"
import { UploadEntity } from "~/interfaces/entities/Upload"
import { uploadsSelectors, uploads } from "../state/uploads"
import { images } from "../state/images"
import { imageTransformations } from "../state/imageTransformations"
import { RootState } from "../store"
import { getImage } from "./images"
import { getImageTransformation } from "./imageTransformations"

export function* getUpload(uploadId: EntityId): SagaIterator<UploadEntity> {
  const upload: UploadEntity = yield select((state: RootState) =>
    uploadsSelectors.selectById(state, uploadId)
  )

  return upload
}

export function* duplicateUpload(
  uploadId: EntityId
): SagaIterator<UploadEntity> {
  const upload: UploadEntity = yield call(getUpload, uploadId)
  const { imageId } = upload

  const image: ImageEntity = yield call(getImage, imageId)
  const { imageTransformId } = image

  const imageTransform: ImageTransformationEntity = yield call(
    getImageTransformation,
    imageTransformId
  )

  const newImageTransform = {
    ...imageTransform,
    id: nanoid(),
  }

  const newImage = {
    ...image,
    id: nanoid(),
    imageTransformId: newImageTransform.id,
  }

  const newUpload = {
    ...upload,
    id: nanoid(),
    imageId: newImage.id,
  }

  const { addOne: addOneUpload } = uploads.actions
  const { addOne: addOneImage } = images.actions
  const { addOne: addOneImageTransform } = imageTransformations.actions

  yield put(addOneImageTransform(newImageTransform))
  yield put(addOneImage(newImage))
  yield put(addOneUpload(newUpload))

  return newUpload
}

export function* waitForUploadReady(uploadId: EntityId) {
  while (true) {
    const upload: UploadEntity = yield call(getUpload, uploadId)
    if (upload.isReady) {
      break
    }
    yield delay(250)
  }
}
